import { QueryClient, useQuery } from '@tanstack/react-query';
import { ActivityPointApi } from 'api/ApiHelper';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';

export const useGetActivityPointMyRankQuery = (enabled = false) =>
  useQuery({
    queryKey: activityPointQueryKey.activityPointMyRank(),
    queryFn: () => ActivityPointApi.getMyRank(),
    enabled,
  });

export const prefetchGetActivityPointMyRankQuery = async (queryClient: QueryClient) =>
  queryClient.prefetchQuery({
    queryKey: activityPointQueryKey.activityPointMyRank(),
    queryFn: () => ActivityPointApi.getMyRank(),
  });
